import React, { useState } from 'react';
import { Button, Checkbox, Input, Text } from 'src/@vymo/ui/atoms';
import { Body, Footer, Header, Modal } from 'src/@vymo/ui/blocks';
import { Editor } from '@monaco-editor/react';
import { generateGsonPojo } from './queries';
import styles from '../index.module.scss';

function PojoModal({ data, open, onClose, onCopy }) {
  const [javaOutput, setJavaOutput] = useState('');

  const [formData, setFormData] = useState<Record<string, any>>({
    packageName: 'com.example',
    className: 'GeneratedClass',
  });

  const handleGenerate = () => {
    try {
      const javaCode = generateGsonPojo(
        data,
        formData.packageName,
        formData.className,
        formData.includeAccessors,
      );
      setJavaOutput(javaCode);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Error generating POJO:', e);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setJavaOutput('');
        onClose();
      }}
      classNames={styles.jsonPlayground__pojoModal}
    >
      <Header>
        <Text type="h4">POJO Generation</Text>
      </Header>
      <Body>
        <div className={styles.jsonPlayground__pojoModal__body}>
          <div className={styles.jsonPlayground__pojoModal__form}>
            <span className={styles.jsonPlayground__pojoModal__form__item}>
              <Text type="label">Package Name</Text>
              <Input
                key="packageName"
                id="packageName-input"
                value={formData.packageName}
                onChange={(val) =>
                  setFormData({ ...formData, packageName: val })
                }
              />
            </span>
            <span className={styles.jsonPlayground__pojoModal__form__item}>
              <Text type="label">Class Name</Text>
              <Input
                key="className"
                id="className-input"
                value={formData.className}
                onChange={(val) => setFormData({ ...formData, className: val })}
              />
            </span>

            <span className={styles.jsonPlayground__pojoModal__form__item}>
              <Text type="label">Additional Methods</Text>
              <Checkbox
                key="includeAccessors"
                id="includeAccessors-input"
                label="Include Accessors (getters/setters)"
                value={formData.includeAccessors}
                onChange={(val) =>
                  setFormData({ ...formData, includeAccessors: val })
                }
              />
            </span>
          </div>
          <div className={styles.jsonPlayground__pojoModal__editor}>
            <Editor
              height="100%"
              defaultLanguage="java"
              value={javaOutput}
              theme="vs"
              onMount={(editor, monaco) => {
                monaco.languages.register({ id: 'java' });
              }}
            />
          </div>
        </div>
      </Body>
      <Footer>
        <div className={styles.jsonPlayground__pojoModal__footer}>
          <Button onClick={handleGenerate}>GENERATE</Button>
          <Button onClick={() => onCopy(javaOutput)} disabled={!javaOutput}>
            COPY
          </Button>
        </div>
      </Footer>
    </Modal>
  );
}

export default PojoModal;
